<template>
  <div>
    <Header :headerContent="headerContent" />
    <cross-page-info :crossPageContent="crossPageContent" />
    <frequently-asked-questions
      :faqTitle="faqTitle"
      :faqTitleDesc="faqTitleDesc"
      :questions="questions"
    />
    <Blog />
    <customer-comments />
  </div>
</template>

<script>
import Header from '@/component/cross-pages/Header'
import crossPageInfo from '@/component/cross-pages/CrossPageInfo'
import frequentlyAskedQuestions from '@/component/expansional-question-panel/AppQuestionPanel'
import Blog from '@/component/alo-kasko-blog-carousel/AppAloKaskoBlog'
import customerComments from '@/component/customer-comments/AppCustomerComments'
import DaskInsuraceData from '@/data/company-page-data/turkiye-sigorta/cross-pages/DaskInsurance'
export default {
  metaInfo: {
    title: 'Türkiye Sigorta (DASK) Zorunlu Deprem Sigortası Prim Hesaplama',
    meta: [
      {
        name: 'description',
        content: 'Online teklif aracından DASK sorgulama veya dask prim hesaplama yaparak, Türkiye Sigorta fiyatlarına erişebilir ve zorunlu deprem sigortanızı yaptırabilirsiniz.'
      }
    ]
  },
  name: 'TürkiyeSigortaDaskInsurance',
  components: {
    Header,
    crossPageInfo,
    frequentlyAskedQuestions,
    Blog,
    customerComments
  },
  data () {
    return {
      headerContent: DaskInsuraceData.headerContent,
      crossPageContent: DaskInsuraceData.crossPageContent,
      faqTitle: DaskInsuraceData.faqTitle,
      faqTitleDesc: DaskInsuraceData.faqTitleDesc,
      questions: DaskInsuraceData.questions,
      getPrice: DaskInsuraceData.getPrice
    }
  }
}
</script>
